// Shared ad sizing logic used by the public AdSlot and the Admin preview, so what Admin
// sees in the editor matches exactly what customers get. Responsive by design (width:100%,
// capped by maxWidth; heights scale down on small screens via the clamp-based values).
export const SIZE_PRESETS = {
  small: { label: "Small banner", maxWidth: 640, height: 90 },
  medium: { label: "Medium", maxWidth: 820, height: 160 },
  large: { label: "Large", maxWidth: 1040, height: 300 },
  full: { label: "Full width", maxWidth: 1280, height: 0 }, // height 0 => natural aspect
  custom: { label: "Custom", maxWidth: 0, height: 0 },
};

export const SIZE_OPTIONS = [
  ["small", "Small"],
  ["medium", "Medium"],
  ["large", "Large"],
  ["full", "Full width"],
  ["custom", "Custom"],
];

// Returns {wrapStyle, mediaStyle} for a given ad descriptor.
export function adStyles(ad) {
  const size = ad.size || "medium";
  const fit = ad.objectFit === "contain" ? "contain" : "cover";
  if (size === "custom") {
    const w = Number(ad.width) || 0;
    const h = Number(ad.height) || 160;
    return {
      wrapStyle: { width: "100%", maxWidth: w ? `${w}px` : "100%", marginLeft: "auto", marginRight: "auto" },
      mediaStyle: { width: "100%", height: `${h}px`, objectFit: fit },
    };
  }
  const p = SIZE_PRESETS[size] || SIZE_PRESETS.medium;
  if (size === "full" || p.height === 0) {
    return {
      wrapStyle: { width: "100%", maxWidth: p.maxWidth ? `${p.maxWidth}px` : "100%", marginLeft: "auto", marginRight: "auto" },
      mediaStyle: { width: "100%", height: "auto", objectFit: fit },
    };
  }
  // Scale fixed heights down on small screens with CSS clamp so it stays responsive.
  const h = p.height;
  const responsiveHeight = `clamp(${Math.round(h * 0.6)}px, ${Math.round(h / 6)}vw, ${h}px)`;
  return {
    wrapStyle: { width: "100%", maxWidth: `${p.maxWidth}px`, marginLeft: "auto", marginRight: "auto" },
    mediaStyle: { width: "100%", height: responsiveHeight, objectFit: fit },
  };
}
